/** Ссылка на поиск в Яндекс.Картах по адресу (без геокодирования на клиенте). */
export function yandexMapsSearchUrl(address: string): string {
  const q = address.trim();
  if (!q) return 'https://yandex.ru/maps/';
  return `https://yandex.ru/maps/?text=${encodeURIComponent(q)}`;
}
